import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { GALLERY_PHOTOS } from "../data/assets";

export const Gallery = () => {
  const { t } = useLang();

  return (
    <section
      id="gallery"
      className="relative py-24 md:py-36 bg-[#050505]"
      data-testid="gallery-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="mb-16 md:mb-20 max-w-3xl"
        >
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-10 bg-[#C5A059]" />
            <span className="text-xs uppercase tracking-[0.3em] text-[#C5A059]">
              {t.gallery.eyebrow}
            </span>
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05]">
            {t.gallery.title}
          </h2>
          <p className="mt-6 text-base md:text-lg text-white/60 font-light max-w-xl">
            {t.gallery.subtitle}
          </p>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-50px" }}
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.1 } },
          }}
          className="grid grid-cols-2 lg:grid-cols-4 auto-rows-[180px] md:auto-rows-[240px] gap-3 md:gap-4"
        >
          {GALLERY_PHOTOS.map((photo, i) => (
            <motion.figure
              key={i}
              variants={{
                hidden: { opacity: 0, y: 30 },
                show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
              }}
              className={`relative overflow-hidden group ${photo.span}`}
              data-testid={`gallery-item-${i}`}
            >
              <img
                src={photo.src}
                alt={photo.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute inset-0 ring-1 ring-inset ring-white/5 group-hover:ring-[#C5A059]/40 transition-all duration-500" />
              <figcaption className="absolute bottom-4 left-4 right-4 text-xs uppercase tracking-[0.2em] text-white/80 opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
                {photo.alt}
              </figcaption>
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
